// import React, { useState } from 'react';
// import Navigation from '../components/Navigation';
// import Hero from '../components/Hero';
// import Statistics from '../components/Statistics';
// import VisionMission from '../components/VisionMission';
// import WhyChooseUs from '../components/WhyChooseUs';
// import Programs from '../components/Programs';
// import Technologies from '../components/Technologies';
// import Testimonials from '../components/Testimonials';
// import Partners from '../components/Partners';
// import Contact from '../components/Contact';
// import FAQs from '../components/FAQs';
// import Footer from '../components/Footer';
// import AIChat from '../components/AIChat';

// const HomePage = () => {
//   return (
//     <div className="min-h-screen bg-white">
//       <Navigation />
//       <Hero />
//       <Statistics />
//       <VisionMission />
//       <WhyChooseUs />
//       <div id="programs">
//         <Programs />
//       </div>
//       <Technologies />
//       <Testimonials />
//       <Partners />
//      <div id="contact">
//         <Contact />
//       </div>
//       <FAQs />
//       <Footer />
//       <AIChat />
//     </div>
//   );
// };

// export default HomePage;
import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Statistics from '../components/Statistics';
import VisionMission from '../components/VisionMission';
import WhyChooseUs from '../components/WhyChooseUs';
import Programs from '../components/Programs';
import Technologies from '../components/Technologies';
import Testimonials from '../components/Testimonials';
import Partners from '../components/Partners';
import Contact from '../components/Contact';
import FAQs from '../components/FAQs';
import Footer from '../components/Footer';
import AIChat from '../components/AIChat';

const HomePage = () => {
  // Effect to handle scrolling after navigation from TeamPage
  useEffect(() => {
    const sectionId = sessionStorage.getItem('scrollToSection');
    if (sectionId) {
      // Small timeout to ensure the page is fully loaded
      const timer = setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
        // Clear the stored section ID
        sessionStorage.removeItem('scrollToSection');
      }, 500);

      return () => clearTimeout(timer);
    }
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <Statistics />
      <VisionMission />
      <WhyChooseUs />

      {/* Programs section with ID for scrolling */}
      <div id="programs">
        <Programs />
      </div>

      <Technologies />
      <Testimonials />
      <Partners />

      {/* Contact section with ID for scrolling */}
      <div id="contact">
        <Contact />
      </div>

      <FAQs />
      <Footer />
      <AIChat />
    </div>
  );
};

export default HomePage;